import ReportTable from '../../../../../components/Grid/ReportTable';

export default function TotemTable(props: any) {
  return <ReportTable model={props.model} columnCount={7} />;
}
